import { GoTrash } from "react-icons/go";
import { useEffect, useState } from "react";
import { CiSquarePlus } from "react-icons/ci";
import { Form, Button, Row, Col, InputGroup, Card } from "react-bootstrap";
import SitePilotIntegrationEditor from "./SitePilotIntegrationEditor";
import Swal from "sweetalert2";
import { integrationServices } from "../../../APIServices/SitePilotManagement/integrationServices";
import { FiPlus } from "react-icons/fi";
import UploadedImageModal from "./UploadedImageModal";
import UseToggle from "../../../Hooks/UseToggle";
import { FaTrashAlt } from "react-icons/fa";

const UpdateSitePilotIntegration = ({
  getSitePilotIntegrationList,
  getSingleSitePilotIntegration,
  singleSitePilotIntegration,
}) => {
  const [tags, setTags] = useState([]);
  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState("active");
  const [subTitle, setSubTitle] = useState("");
  const [type, setType] = useState("published");
  const [icon, setIcon] = useState("");
  const [title, setTitle] = useState("");
  const [banner, setBanner] = useState([]);
  const [bannerIndex, setBannerIndex] = useState(null);
  const [sliders, setSliders] = useState(false);
  const [installButton, setInstallButton] = useState(false);
  const [overview, setOverview] = useState("");
  const [installationDetails, setInstallationDetails] = useState("");
  const [installButtonActionType, setInstallButtonActionType] = useState("activate");
  const [installButtonKey, setInstallButtonKey] = useState("");
  const [learnMoreButton, setLearnMoreButton] = useState(false);
  const [learnMoreButtonLink, setLearnMoreButtonLink] = useState("");
  const toggles = UseToggle();

  const updatedSitePilotIntegration = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this integration?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      setLoader(true);
      let userData = {};
      userData.integrationId = singleSitePilotIntegration?.integrationId;
      userData.title = title;
      userData.subTitle = subTitle
      userData.banners = banner
      userData.type = type
      userData.sliderType = true;
      userData.sliders = sliders
      userData.status = status;
      userData.overview = overview;
      userData.installationDetails = installationDetails;
      userData.installButtonType = true;
      userData.installButton = installButton;
      userData.installButtonActionType = installButtonActionType
      userData.installButtonKey = installButtonKey
      userData.learnMoreButtonType = true
      userData.learnMoreButton = learnMoreButton
      userData.learnMoreButtonLink = learnMoreButtonLink
      userData.tagType = true;
      userData.tags = tags;
      let data =
        await integrationServices.updatedSitePilotIntegration(userData);
      if (data?.statusCode === 200) {
        getSitePilotIntegrationList();
        getSingleSitePilotIntegration();
        clearData();
      }
      setLoader(false);
    });
  };

  const clearData = () => {
    setIcon("");
    setTitle("");
    setSubTitle("");
    setBanner([]);
    setSliders(false);
    setType("published");
    setOverview("");
    setInstallationDetails("");
    setInstallButton(false);
    setInstallButtonActionType("activate");
    setInstallButtonKey("");
    setLearnMoreButton(false);
    setLearnMoreButtonLink("");
    setTags([]);
    setStatus("active");
    setLoader(false);
  };

  const addTagsRow = () => {
    setTags([...tags, ""]);
  };

  const removeTagsRow = (index) => {
    const updated = [...tags];
    updated.splice(index, 1);
    setTags(updated);
  };

  const handleTagsChange = (index, value) => {
    const updated = [...tags];
    updated[index] = value;
    setTags(updated);
  };

  const hasEmptyTag = () => {
    return tags?.some((tag) => tag.trim() === "");
  };

  const addBannerUrl = (url) => {
    setBanner((prev) => [...prev, url]);
  };

  const updateBannerUrl = (newUrl) => {
    setBanner((prev) =>
      prev.map((item, i) => (i === bannerIndex ? newUrl : item))
    );
  };

  const removeBannerUrl = (index) => {
    setBanner((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (singleSitePilotIntegration) {
      setIcon(singleSitePilotIntegration?.icon || "");
      setTitle(singleSitePilotIntegration?.title || "");
      setOverview(singleSitePilotIntegration?.overview || "");
      setTags(singleSitePilotIntegration?.tags || []);
      setStatus(singleSitePilotIntegration?.status);
      setSubTitle(singleSitePilotIntegration?.subTitle || "");
      setSliders(singleSitePilotIntegration?.sliders || false);
      setInstallationDetails(
        singleSitePilotIntegration?.installationDetails || "",
      );
      setInstallButton(singleSitePilotIntegration?.installButton || false);
      setInstallButtonActionType(singleSitePilotIntegration?.installButtonActionType || "activate");
      setInstallButtonKey(singleSitePilotIntegration?.installButtonKey || "");
      setLearnMoreButton(singleSitePilotIntegration?.learnMoreButton || false);
      setLearnMoreButtonLink(singleSitePilotIntegration?.learnMoreButtonLink || "");
      setBanner(singleSitePilotIntegration?.banners || []);
      setType(singleSitePilotIntegration?.type || "published");
    }
  }, [singleSitePilotIntegration]);

  return (
    <>
      <Form>
        <div
          className="overflow-auto p-3"
          style={{ height: "calc(100vh - 169px)" }}
        >
          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Icon
                </Form.Label>
                <div title="Add Icon">
                  <Button
                    onClick={toggles.setToggle}
                    variant="light"
                    className="w-100 border hstack gap-2 justify-content-center"
                    style={{ height: 108 }}
                  >
                    {icon ? (
                      <img className="w-auto h-50" src={icon} />
                    ) : (
                      <>
                        <FiPlus /> Add Icon
                      </>
                    )}
                  </Button>
                </div>
              </Form.Group>
            </Col>
            <Col md={9}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                  Title
                </Form.Label>
                <Form.Control
                  type="text"
                  style={{ fontSize: 12 }}
                  placeholder="Enter Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label
                      className="fw-bold mb-1"
                      style={{ fontSize: 13 }}
                    >
                      Status
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value={"active"}>Active</option>
                      <option value={"inactive"}>Inactive</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label
                      className="fw-bold mb-1"
                      style={{ fontSize: 13 }}
                    >
                      Type
                    </Form.Label>
                    <Form.Select
                      style={{ fontSize: 12 }}
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value={"published"}>Published</option>
                      <option value={"comingSoon"}>Coming Soon</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <div className="hstack gap-2 mb-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Banner
              </Form.Label>
              <div className="vr"></div>
              <Form.Group className="mb-1 hstack gap-2">
                <Form.Check
                  type="switch"
                  checked={sliders}
                  onChange={(e) => setSliders(e.target.checked)}
                  style={{ fontSize: 12 }}
                />
                <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                  Slider
                </Form.Label>
              </Form.Group>
            </div>
            <Row className="g-2">
              {banner?.map((icon, index) => (
                <Col key={index} md={3}>
                  <div title="Remove Banner" className="position-relative">
                    <Button
                      onClick={() => { toggles.setToggle2(); setBannerIndex(index) }}
                      variant="light"
                      className="w-100 border hstack gap-2 justify-content-center"
                      style={{ height: 108 }}
                    >
                      <img className="w-auto h-50" src={icon} />
                    </Button>
                    <div className="bg-white position-absolute rounded-circle" style={{ top: -10, right: -3 }}>
                      <Button variant="outline-danger" className="rounded-circle p-0" style={{ width: 25 }} onClick={() => removeBannerUrl(index)}>
                        <FaTrashAlt style={{ fontSize: 12 }} />
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
              <Col md={3}>
                <div title="Add Banner">
                  <Button
                    onClick={toggles.setToggle1}
                    variant="light"
                    className="w-100 border hstack gap-2 justify-content-center"
                    style={{ height: 108 }}
                  >
                    <FiPlus /> Add Banner
                  </Button>
                </div>
              </Col>
            </Row>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
              Overview
            </Form.Label>
            <SitePilotIntegrationEditor
              editorValue={overview}
              setEditorValue={setOverview}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <div className="hstack gap-2 mb-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Installation Details
              </Form.Label>
              <div className="vr"></div>
              <Form.Group className="mb-1 hstack gap-2">
                <Form.Check
                  type="switch"
                  checked={installButton}
                  onChange={(e) => setInstallButton(e.target.checked)}
                  style={{ fontSize: 12 }}
                />
                <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                  Install Button
                </Form.Label>
              </Form.Group>
              {installButton &&
                <>
                  <div className="vr"></div>
                  <Form.Group className="mb-1 hstack gap-2">
                    <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                      Activation Type
                    </Form.Label>
                    <Form.Check
                      type="switch"
                      checked={installButtonActionType === "link"}
                      onChange={(e) => setInstallButtonActionType(installButtonActionType === "activate" ? "link" : "activate")}
                      style={{ fontSize: 12 }}
                    />
                    <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
                      Link Type
                    </Form.Label>
                  </Form.Group>
                </>
              }
            </div>
            <SitePilotIntegrationEditor
              editorValue={installationDetails}
              setEditorValue={setInstallationDetails}
            />
          </Form.Group>
          {installButton &&
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                {installButtonActionType === "activate" ? "Install Button Id" : "Install Button Link"}
              </Form.Label>
              <Form.Control
                type={installButtonActionType === "activate" ? "text" : "url"}
                style={{ fontSize: 12 }}
                placeholder={`Enter ${installButtonActionType === "activate" ? "Install Button Id" : "Install Button Link"}`}
                value={installButtonKey}
                onChange={(e) => setInstallButtonKey(e.target.value)}
              />
            </Form.Group>
          }
          <Form.Group className="mb-3 hstack gap-2">
            <Form.Check
              type="switch"
              checked={learnMoreButton}
              onChange={(e) => setLearnMoreButton(e.target.checked)}
              style={{ fontSize: 12 }}
            />
            <Form.Label className="fw-bold m-0" style={{ fontSize: 13 }}>
              Learn More Button
            </Form.Label>
          </Form.Group>
          {learnMoreButton &&
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Learn More Button Link
              </Form.Label>
              <Form.Control
                type="url"
                style={{ fontSize: 12 }}
                placeholder="Enter Learn More Button Link"
                value={learnMoreButtonLink}
                onChange={(e) => setLearnMoreButtonLink(e.target.value)}
              />
            </Form.Group>
          }
          <Form.Group>
            <div className="hstack gap-2">
              <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                Tags
              </Form.Label>
              <CiSquarePlus
                title="Add More"
                onClick={addTagsRow}
                className="mb-1 text-success CP"
              />
            </div>
            <Row>
              {tags?.map((tag, index) => {
                return (
                  <Col md={3} className="mb-2">
                    <InputGroup key={index}>
                      <Form.Control
                        placeholder="Enter Tag"
                        value={tag}
                        style={{ fontSize: 12 }}
                        onChange={(e) =>
                          handleTagsChange(index, e.target.value)
                        }
                      />
                      <InputGroup.Text>
                        <GoTrash
                          style={{ fontSize: 12 }}
                          className="text-danger CP"
                          title="Delete"
                          onClick={() => removeTagsRow(index)}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  </Col>
                );
              })}
            </Row>
          </Form.Group>
        </div>
        <div className="d-flex justify-content-end gap-2 p-2">
          <Button variant="light" style={{ fontSize: 12 }} onClick={clearData}>
            Cancel
          </Button>
          <Button
            disabled={
              !status ||
              !icon ||
              !title ||
              !subTitle ||
              !type ||
              !overview ||
              !installationDetails ||
              banner?.length === 0 ||
              !installationDetails ||
              loader ||
              hasEmptyTag()
            }
            onClick={updatedSitePilotIntegration}
            style={{ fontSize: 12 }}
          >
            Save
          </Button>
        </div>
      </Form>
      <UploadedImageModal
        Show={!toggles?.toggle}
        Hide={toggles?.setToggle}
        Title={`Media Library`}
        onSelect={(icon) => setIcon(icon)}
      />
      <UploadedImageModal
        Show={!toggles?.toggle1}
        Hide={toggles?.setToggle1}
        Title={`Media Library`}
        onSelect={(icon) => addBannerUrl(icon)}
      />
      <UploadedImageModal
        Show={!toggles?.toggle2}
        Hide={toggles?.setToggle2}
        Title={`Media Library`}
        onSelect={(icon) => updateBannerUrl(icon)}
      />
    </>
  );
};

export default UpdateSitePilotIntegration;
